import firebase from "firebase/app";
import "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCC5P0Qdjt7v8ykOPs14yqjDJYplO6HNJI",
  authDomain: "openhouse-7ef82.firebaseapp.com",
  databaseURL: "https://openhouse-7ef82.firebaseio.com",
  projectId: "openhouse-7ef82",
  storageBucket: "openhouse-7ef82.appspot.com",
  messagingSenderId: "413073881902",
  appId: "1:413073881902:web:74406c22655ccc921198bf",
  measurementId: "G-8MCELL5ZL0",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.functions().useFunctionsEmulator("http://localhost:4000");

const db = firebase.firestore();

export default db;
